import { Palette } from '@opsbase/lib-palette';
import React from 'react';
export function DetailsReportSwab({ color = Palette.White }) {
    return color ? (React.createElement("div", { style: {
            backgroundColor: color.main,
            border: `1px solid ${color.dark}`,
            display: 'inline-block',
            width: 16,
            height: 16,
            marginRight: 8,
        } }, "\u00A0")) : null;
}
export default DetailsReportSwab;
